module.exports = __webpack_public_path__ + "static/img/dealuser.39dc74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/dealuser.png
// module id = 1216
// module chunks = 0